import React, { useState } from 'react';

import cls from 'classnames';

import './styles.css';
import './burgers.css';

import Spreader from '../Spreader';
import Menu from './Menu';

export default props => {
  const [isActive, toggleActive] = useState(false);

  const menuTrigger = (
    <button
      className={
        'hamburger hamburger--collapse ' + (isActive ? 'is-active' : '')
      }
      type="button"
      onClick={() => toggleActive(!isActive)}
    >
      <span className="hamburger-box">
        <span className="hamburger-inner"></span>
      </span>
    </button>
  );

  return (
    <div className="Header">
      <Spreader>
        <div className="Header__wrap">
          <a href="https://www.kommersant.ru" target="_blank">
            <div className="Header__kommersant-logo"></div>
          </a>
          <a href="https://www.megafon.ru/?utm_source=kommersant&utm_medium=banner&utm_campaign=pr_special_project_2019-12-20" target="_blank">
            <div className="Header__megafon-logo"></div>
          </a>
          <div className="Header__trigger">{menuTrigger}</div>
        </div>
      </Spreader>
      <div
        className={cls('Header__sidebar', {
          'Header__sidebar--isActive': isActive,
        })}
      >
        <div className={'Header__sidebar-trigger'}>{menuTrigger}</div>
        <Menu closeSidebar={toggleActive} />
      </div>
    </div>
  );
};
